import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Image from 'global/Image';
import CloseSvg from 'global/Icons/CloseSvg';
import { ModalConfirmation } from './styled';

const ModalNavigateConfirmation = ({
  visible = false,
  onLeave = () => {},
  onStay = () => {},
}) => (
  <ModalConfirmation
    visible={visible}
    centered
    width="400px"
    closeIcon={<CloseSvg width="10px" height="10px" />}
    onCancel={onStay}
  >
    {/* @ts-expect-error */}
    <Flex align="center" direction="column" py="30px">
      <Image
        src="/icon/password-navigation.svg"
        alt="lock"
        style={{ marginBottom: '18px' }}
      />
      <Text weight="700" size="16px" height="26px">
        Are You Sure Want to Leave This Page?
      </Text>
      <Text weight="400" size="14px" height="22px">
        If you leave now, you`&apos;`ll have to start over.
      </Text>
    </Flex>

    <Flex justify="center">
      {/* @ts-expect-error */}
      <Button block height="40px" radius="4px" mr="5px" onClick={onStay}>
        <b>Stay Here</b>
      </Button>
      <Button
        // @ts-expect-error
        ml="5px"
        type="borderless"
        block
        height="40px"
        radius="4px"
        style={{ backgroundColor: '#D74342', color: '#FFFFFF' }}
        onClick={onLeave}
      >
        <b>Leave</b>
      </Button>
    </Flex>
  </ModalConfirmation>
);

export default ModalNavigateConfirmation;
